export const CompanyCulturalRouting = [
  {
    path: "/information-manage/company-cultural/list",
    name: "company-cultural-list",
    meta: { title: "企业文化风采" },
    component: () => import("@/views/information-manage/company-cultural/list/index.vue"),
  },
  {
    hidden: true,
    path: "/information-manage/company-cultural/create",
    name: "company-cultural-create",
    meta: { title: "新增企业文化风采",comName:"informationManageCompanyCulturalFormCreate" },
    component: () => import("@/views/information-manage/company-cultural/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/information-manage/company-cultural/edit/:id",
    name: "company-cultural-edit",
    meta: { title: "编辑企业文化风采",comName:"informationManageCompanyCulturalFormCreate" },
    component: () => import("@/views/information-manage/company-cultural/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/information-manage/company-cultural/detail/:id",
    name: "company-cultural-detail",
    meta: { title: "企业文化风采详情" },
    component: () => import("@/views/information-manage/company-cultural/form-detail/index.vue"),
  },
];
